'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index_es = require('./index.es-1f72f6f2.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n  padding: 10px 0;\n  box-shadow: 0px 0px 4px ", "40;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  padding: 10px 0;\n  box-shadow: 0px 0px 4px ", "40;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminBlack;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
});
var Icon = styled__default(index_es.FontAwesomeIcon)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-size: 32px;\n  margin-left: 30px;\n  color: ", ";\n  opacity: ", ";\n"], ["\n  font-size: 32px;\n  margin-left: 30px;\n  color: ", ";\n  opacity: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.3 : 1);
});
var templateObject_1, templateObject_2;

exports.Container = Container;
exports.Icon = Icon;
